/** Batch location used by the Documents tab + Fund profile filtered picklist (GET /documents/v1/DocumentTypes). */
export const DOCUMENT_TYPE_LOCATION_DOCUMENT = "document";

/** Sort column applied to all document type picklist requests. */
export const DOCUMENT_TYPE_SORT_COLUMN_NAME = "name";
